import { useSyncExternalStore } from 'react';
import { messagingStore } from '../store';

/**
 * Subscribe a component to the messaging store. Re-renders whenever any
 * thread or message changes. Backed by Supabase + Realtime (see
 * ../store.ts); call `messagingStore.bootstrap(self)` once per session.
 */
export const useMessagingStore = () => {
  const subscribe = (cb: () => void) => messagingStore.subscribe(cb);
  // Monotonic revision counter — changes on every mutation so React always
  // schedules a render when the store notifies.
  const getSnapshot = () => messagingStore.revision();
  const getServerSnapshot = () => 0;
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return messagingStore;
};
